import React from 'react';
import { __ } from '../core/utils';
import TimesheetReportExportForm from '../forms/timesheets/TimesheetReportExportForm';
import modalStyles from '../styles/views/timesheets/TimesheetReport.scss';
import styles from '../styles/wizards/TimesheetReportExportWizard.scss';

const TimesheetReportExportWizard = ({
  exportMonth,
  exportYear,
  onMonthChange,
  onYearChange,
  onClose,
  onSubmit,
}) => {
  return (
    <div className={modalStyles.modalOverlay} onClick={onClose}>
      <div
        className={modalStyles.modalCard}
        onClick={(event) => event.stopPropagation()}
      >
        <div className={styles.header}>
          <div className={styles.left}>
            <span>{__('timesheet-report.export.title')}</span>
            <span>{__('timesheet-report.export.subtitle')}</span>
          </div>
        </div>

        <div className={styles.body}>
          <TimesheetReportExportForm
            exportMonth={exportMonth}
            exportYear={exportYear}
            onMonthChange={onMonthChange}
            onYearChange={onYearChange}
            onClose={onClose}
            onSubmit={onSubmit}
          />
        </div>
      </div>
    </div>
  );
};

export default TimesheetReportExportWizard;
